<template>
  <div class="content-item mb16">
    <border-radius
      :borderTypeFlag.sync="borderTypeFlag"
      :borderRadius.sync="borderRadius"
      :borderTopLeftRadius.sync="borderTopLeftRadius"
      :borderTopRightRadius.sync="borderTopRightRadius"
      :borderBottomRightRadius.sync="borderBottomRightRadius"
      :borderBottomLeftRadius.sync="borderBottomLeftRadius"
    />
    <!--    <div class="border-radius-header">-->
    <!--      <span class="ml24">圆角 <span @click="reset(30)" class="icon-portal-refresh"></span></span>-->
    <!--      <div class="border-radius-btn">-->
    <!--        <span-->
    <!--          class="icon-portal-adjustment1"-->
    <!--          :class="borderTypeFlag == 2 ? 'select' : ''"-->
    <!--          @click="changeBorderRadiusType(2)"-->
    <!--        ></span>-->
    <!--        <span-->
    <!--          class="icon-portal-full-screen1"-->
    <!--          :class="borderTypeFlag == 1 ? 'select' : ''"-->
    <!--          @click="changeBorderRadiusType(1)"-->
    <!--        ></span>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div v-if="borderTypeFlag == 1">-->
    <!--      <div class="verticallyCenter mt16">-->
    <!--        <div class="radius_bg_1 mr16 ml24"></div>-->
    <!--        <el-slider-->
    <!--          :show-tooltip="false"-->
    <!--          class="mr16 flex1"-->
    <!--          style="height: 4px"-->
    <!--          v-model="borderTopLeftRadius"-->
    <!--        ></el-slider>-->
    <!--        <el-input-->
    <!--          v-inputHandle="{ this1, type: 'borderTopLeftRadius' }"-->
    <!--          type="number"-->
    <!--          class=""-->
    <!--          style="width: 80px; height: 28px"-->
    <!--          v-model="borderTopLeftRadius"-->
    <!--          placeholder="请输入"-->
    <!--        >-->
    <!--          <template slot="suffix">-->
    <!--            <span class="suffix_text">px</span>-->
    <!--          </template>-->
    <!--        </el-input>-->
    <!--      </div>-->
    <!--      <div class="verticallyCenter mt16">-->
    <!--        <div class="radius_bg_2 mr16 ml24"></div>-->
    <!--        <el-slider-->
    <!--          :show-tooltip="false"-->
    <!--          class="mr16 flex1"-->
    <!--          style="height: 4px"-->
    <!--          v-model="borderTopRightRadius"-->
    <!--        ></el-slider>-->
    <!--        <el-input-->
    <!--          v-inputHandle="{ this1, type: 'borderTopRightRadius' }"-->
    <!--          type="number"-->
    <!--          class=""-->
    <!--          style="width: 80px; height: 28px"-->
    <!--          v-model="borderTopRightRadius"-->
    <!--          placeholder="请输入"-->
    <!--        >-->
    <!--          <template slot="suffix">-->
    <!--            <span class="suffix_text">px</span>-->
    <!--          </template>-->
    <!--        </el-input>-->
    <!--      </div>-->
    <!--      <div class="verticallyCenter mt16">-->
    <!--        <div class="radius_bg_3 mr16 ml24"></div>-->
    <!--        <el-slider-->
    <!--          class="mr16 flex1"-->
    <!--          style="height: 4px"-->
    <!--          :show-tooltip="false"-->
    <!--          v-model="borderBottomRightRadius"-->
    <!--        ></el-slider>-->
    <!--        <el-input-->
    <!--          v-inputHandle="{ this1, type: 'borderBottomRightRadius' }"-->
    <!--          type="number"-->
    <!--          class=""-->
    <!--          style="width: 80px; height: 28px"-->
    <!--          v-model="borderBottomRightRadius"-->
    <!--          placeholder="请输入"-->
    <!--        >-->
    <!--          <template slot="suffix">-->
    <!--            <span class="suffix_text">px</span>-->
    <!--          </template>-->
    <!--        </el-input>-->
    <!--      </div>-->
    <!--      <div class="verticallyCenter mt16">-->
    <!--        <div class="radius_bg_4 mr16 ml24"></div>-->
    <!--        <el-slider-->
    <!--          class="mr16 flex1"-->
    <!--          style="height: 4px"-->
    <!--          :show-tooltip="false"-->
    <!--          v-model="borderBottomLeftRadius"-->
    <!--        ></el-slider>-->
    <!--        <el-input-->
    <!--          v-inputHandle="{ this1, type: 'borderBottomLeftRadius' }"-->
    <!--          type="number"-->
    <!--          class=""-->
    <!--          style="width: 80px; height: 28px"-->
    <!--          v-model="borderBottomLeftRadius"-->
    <!--          placeholder="请输入"-->
    <!--        >-->
    <!--          <template slot="suffix">-->
    <!--            <span class="suffix_text">px</span>-->
    <!--          </template>-->
    <!--        </el-input>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div v-else class="verticallyCenter mt16">-->
    <!--      <el-slider class="mr16 ml24 flex1" style="height: 4px" :show-tooltip="false" v-model="borderRadius"></el-slider>-->
    <!--      <el-input-->
    <!--        v-inputHandle="{ this1, type: 'borderRadius' }"-->
    <!--        type="number"-->
    <!--        class=""-->
    <!--        style="width: 80px; height: 28px"-->
    <!--        v-model="borderRadius"-->
    <!--        placeholder="请输入"-->
    <!--      >-->
    <!--        <template slot="suffix">-->
    <!--          <span class="suffix_text">px</span>-->
    <!--        </template>-->
    <!--      </el-input>-->
    <!--    </div>-->
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      // borderTypeFlag: 2,
      this1: this
    }
  },
  computed: {
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$emit("update", "borderTypeFlag", newVal)
      }
    },
    borderRadius: {
      get() {
        const data = this.options //获取数据
        const dataMap = [
          "borderTopLeftRadius",
          "borderTopRightRadius",
          "borderBottomRightRadius",
          "borderBottomLeftRadius"
        ] //过滤工具数组
        return (
          data &&
          parseInt(
            dataMap.reduce((prevK, currK, currKIndex) => {
              if (currKIndex - 1 === 0) {
                return Number(data[prevK]) + Number(data[currK])
              } else {
                return prevK + Number(data[currK])
              }
            }) / dataMap.length
          )
        )
      },
      set(newVal) {
        this.$emit("update", "borderTopLeftRadius", newVal)
        this.$emit("update", "borderTopRightRadius", newVal)
        this.$emit("update", "borderBottomRightRadius", newVal)
        this.$emit("update", "borderBottomLeftRadius", newVal)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius
      },
      set(newVal) {
        this.$emit("update", "borderTopLeftRadius", newVal)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius
      },
      set(newVal) {
        this.$emit("update", "borderTopRightRadius", newVal)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius
      },
      set(newVal) {
        this.$emit("update", "borderBottomRightRadius", newVal)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$emit("update", "borderBottomLeftRadius", newVal)
      }
    }
  },
  methods: {
    // reset(val) {
    //   this.borderRadius = val
    // },
    // changeBorderRadiusType(value) {
    //   this.borderTypeFlag = value
    //   if (this.borderTypeFlag === 1) {
    //   } else {
    //     this.$emit("update", "borderTypeFlag", value)
    //   }
    // }
  }
}
</script>

<style scoped></style>
